export var MessageType;
(function (MessageType) {
    MessageType["Initialize"] = "TylerEmbeddedApplication.Initialize";
    MessageType["Close"] = "TylerEmbeddedApplication.Close";
    MessageType["Resize"] = "TylerEmbeddedApplication.Resize";
    MessageType["Theme"] = "TylerEmbeddedApplication.Theme";
})(MessageType || (MessageType = {}));
export var ParameterType;
(function (ParameterType) {
    ParameterType["Origin"] = "origin";
    ParameterType["HostId"] = "hostId";
    ParameterType["EmbeddedId"] = "embeddedId";
    ParameterType["FullScreen"] = "fullScreen";
})(ParameterType || (ParameterType = {}));
